module.exports = __webpack_public_path__ + "media/images/badge-packing-a6e487e1bf638af3e2c83770d4df0b8e.svg";